


export const select = {
    entity:"",
    sortBy:"id",
    sortDirection:"DESC",
    limit1:"0",
    limit2:"10",
    mainFilter: { fields:[], values:[] },
    andFilter:  { fields:[], values:[] }
}



//OBJECT TO SEND TO update.php
export const insert = {
    entity:"",
    id:"",
    fields: [],
    values: [],
    multiTables:[]
}



export const update = {
    entity:"",
    id:"",
    fields: [],
    values: [],
    multiTables:[]
}






export const deleteEntity = {
    entity:"",
    ids   :[]
}



